var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceOrderIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m460.176 248c4.418 0 8 3.582 8 8s-3.582 8-8 8h-151.532l86.562 29.333c3.327 1.127 5.425 4.234 5.424 7.562h.013v90.066c0 4.418-3.582 8-8 8s-8-3.582-8-8v-84.346l-120.643-40.882v194.443c0 4.418-3.582 8-8 8s-8-3.582-8-8v-194.443l-120.644 40.882v84.346c0 4.418-3.582 8-8 8s-8-3.582-8-8v-90.066c0-3.699 2.511-6.812 5.923-7.727l86.076-29.168h-151.531c-4.418 0-8-3.582-8-8s3.582-8 8-8h151.534l-86.078-29.169c-3.411-.915-5.923-4.027-5.923-7.727v-90.066c0-4.418 3.582-8 8-8s8 3.582 8 8v84.346l120.643 40.882v-194.442c0-4.418 3.582-8 8-8s8 3.582 8 8v194.443l120.643-40.882v-84.346c0-4.418 3.582-8 8-8s8 3.582 8 8v90.066h-.013c0 3.328-2.097 6.435-5.424 7.562l-86.564 29.333z",
    fill: "#b3d1d6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m119.356 168.017-42.823-24.725v-49.448l42.823-24.724 42.824 24.724v49.448z",
    fill: "#ffd92d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.356 118.568 42.824-24.724-42.824-24.724-42.823 24.724v49.448l42.823 24.725z",
    fill: "#fcb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.533 93.844v49.448l42.823 24.725v-49.449z",
    fill: "#ffc600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 111.272-42.824-24.724v-49.449l42.824-24.724 42.824 24.724v49.449z",
    fill: "#ffd92d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 61.823 42.824-24.724-42.824-24.724-42.824 24.724v49.449l42.824 24.724z",
    fill: "#fcb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.176 37.099v49.449l42.824 24.724v-49.449z",
    fill: "#ffc600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m392.643 168.017-42.823-24.725v-49.448l42.823-24.724 42.824 24.724v49.448z",
    fill: "#ffd92d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.643 118.568 42.824-24.724-42.824-24.724-42.823 24.724v49.448l42.823 24.725z",
    fill: "#fcb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.82 93.844v49.448l42.823 24.725v-49.449z",
    fill: "#ffc600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m460.176 305.449-42.823-24.725v-49.448l42.823-24.724 42.824 24.724v49.448z",
    fill: "#ffd92d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m460.176 256 42.824-24.724-42.824-24.724-42.823 24.724v49.448l42.823 24.725z",
    fill: "#fcb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.353 231.276v49.448l42.823 24.725v-49.449z",
    fill: "#ffc600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m392.643 442.88-42.823-24.725v-49.448l42.823-24.724 42.824 24.724v49.448z",
    fill: "#ffd92d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.643 393.431 42.824-24.724-42.824-24.724-42.823 24.724v49.448l42.823 24.725z",
    fill: "#fcb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.82 368.707v49.448l42.823 24.725v-49.449z",
    fill: "#ffc600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 499.625-42.824-24.724v-49.449l42.824-24.724 42.824 24.724v49.449z",
    fill: "#ffd92d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 450.176 42.824-24.724-42.824-24.724-42.824 24.724v49.449l42.824 24.724z",
    fill: "#fcb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.176 425.452v49.449l42.824 24.724v-49.449z",
    fill: "#ffc600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m119.356 442.88-42.823-24.725v-49.448l42.823-24.724 42.824 24.724v49.448z",
    fill: "#ffd92d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.356 393.431 42.824-24.724-42.824-24.724-42.823 24.724v49.448l42.823 24.725z",
    fill: "#fcb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.533 368.707v49.448l42.823 24.725v-49.449z",
    fill: "#ffc600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m51.823 305.449-42.823-24.725v-49.448l42.823-24.724 42.824 24.724v49.448z",
    fill: "#ffd92d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.823 256 42.824-24.724-42.824-24.724-42.823 24.724v49.448l42.823 24.725z",
    fill: "#fcb700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 231.276v49.448l42.823 24.725v-49.449z",
    fill: "#ffc600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 345.968-77.915-44.984v-89.968l77.915-44.985 77.915 44.985v89.968z",
    fill: "#64b4f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 256 77.915-44.985-77.915-44.984-77.915 44.984v89.969l77.915 44.985z",
    fill: "#2d8ff0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.085 211.015v89.969l77.915 44.985v-89.969z",
    fill: "#42a4f4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOrderIntegration);
export default __webpack_public_path__ + "static/media/service-order-integration.76b9114d1fd1c1c39fdff51f243763fa.svg";
export { ForwardRef as ReactComponent };